import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import SmallLoading from '../../../../common/SmallLoading/SmallLoading';
import {
  getBrandOfSelectedTicket,
  getRbiCustomerId,
  getSimplrAccountIdOfSelectedTicket,
} from '../../../../../extractFromState';
import { getShopNameOfSelectedOrder } from '../../../../../selectors/tools';
import { handleError } from '../../../../../services/ErrorService/ErrorService';
import { fetchRbiHockeyChallengeInfo } from '../../../../../api/orders/rbi';
import { SpinnerWrapper, Spreadsheet, NoData } from './DTRbiHockeyChallengeWidget.styles';
import { OverallStats } from './OverallStats';
import { GameHistory } from './GameHistory';
import { parseDateFromDescription } from '../../../../../util';

export const NODATA = <NoData>N/A</NoData>;
const DTRbiHockeyChallengeWidget = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [hockeyChallengeInfo, setHockeyChallengeInfo] = useState([]);
  const [selectedChallengeId, setSelectedChallengeId] = useState(null);
  const simplrAccountId = useSelector(getSimplrAccountIdOfSelectedTicket);
  const customerId = useSelector(getRbiCustomerId);
  const domain = useSelector(getShopNameOfSelectedOrder);
  const brandName = useSelector(getBrandOfSelectedTicket);

  const handleChangeSelectedChallengeId = (challengeId) => {
    setSelectedChallengeId(challengeId === selectedChallengeId ? null : challengeId);
  };

  const fetchHockeyChallengeInfo = useCallback(async () => {
    try {
      setIsLoading(true);
      const result = await fetchRbiHockeyChallengeInfo(simplrAccountId, domain, brandName, customerId);
      setHockeyChallengeInfo(result);
    } catch (error) {
      handleError({ error, customMessage: 'Error fetching Hockey Challenge Info', showPopup: true });
    } finally {
      setIsLoading(false);
    }
    // eslint-disable-next-line
  }, [simplrAccountId, domain, brandName, customerId]);

  useEffect(() => {
    fetchHockeyChallengeInfo();
  }, [fetchHockeyChallengeInfo]);

  const currentChallenges = hockeyChallengeInfo?.userStats?.challenges.map((challenge) => {
    const { startDate, endDate } = parseDateFromDescription(challenge.description);

    return {
      title: challenge.title,
      status: challenge.status,
      startDate,
      endDate,
    };
  });

  const correctPicks = hockeyChallengeInfo?.userStats?.season?.correctPicks ?? NODATA;
  const daysPlayed = hockeyChallengeInfo?.userStats?.season?.daysPlayed ?? NODATA;
  const pickAccuracy = hockeyChallengeInfo?.userStats?.season?.pickAccuracy ?? NODATA;
  const currentRank = hockeyChallengeInfo?.userStats?.season?.rank ?? NODATA;
  const previousRank = hockeyChallengeInfo?.userStats?.postseason?.rank ?? NODATA;

  if (isLoading) {
    return (
      <SpinnerWrapper data-testid="notes-spinner-wrapper">
        <SmallLoading />
      </SpinnerWrapper>
    );
  }

  return (
    <>
      <OverallStats
        correctPicks={correctPicks}
        daysPlayed={daysPlayed}
        pickAccuracy={pickAccuracy}
        currentRank={currentRank}
        previousRank={previousRank}
      />

      <Spreadsheet className="fs-block">
        {!!hockeyChallengeInfo?.history?.length && (
          <GameHistory
            history={hockeyChallengeInfo.history}
            selectedChallengeId={selectedChallengeId}
            handleChangeSelectedChallengeId={handleChangeSelectedChallengeId}
            currentChallenges={currentChallenges}
          />
        )}
      </Spreadsheet>
    </>
  );
};
export default DTRbiHockeyChallengeWidget;
